module.exports = new __parcel__URL__("Isdalen_premium_ICECREAM_negativ_positiv.124b62c0.svg").toString();